import { Layout as AntdLayout } from 'antd'
import type { LayoutProps as AntdLayoutProps } from 'antd'

type ContentProps = AntdLayoutProps

export function Content(props: ContentProps) {
  return <AntdLayout.Content {...props} />
}
